module.exports = __webpack_public_path__ + "static/media/zs.434e7e58.png";